module.exports = __webpack_public_path__ + "img/verification.ca9d54c1.svg";